export default {
  color: {
    height: '34px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: 'rgb(246, 246, 246)',
  }
};



// WEBPACK FOOTER //
// ./src/common/СolorPicker/style.js